/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Remove_Preset_Button_TitleInputs */

const en_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Preset`)
};

const fr_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le preset`)
};

const de_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellung entfernen`)
};

const it_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi preimpostazione`)
};

const ru_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить предустановку`)
};

const es_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar ajuste preestablecido`)
};

const zh_cn2_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除预设`)
};

const ja_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを削除`)
};

const hi_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट हटाएं`)
};

const pt_pt2_styles_remove_preset_button_title = /** @type {(inputs: Styles_Remove_Preset_Button_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover predefinição`)
};

/**
* | output |
* | --- |
* | "Remove Preset" |
*
* @param {Styles_Remove_Preset_Button_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_remove_preset_button_title = /** @type {((inputs?: Styles_Remove_Preset_Button_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Remove_Preset_Button_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_styles_remove_preset_button_title(inputs)
	if (locale === "de") return de_styles_remove_preset_button_title(inputs)
	if (locale === "it") return it_styles_remove_preset_button_title(inputs)
	if (locale === "ru") return ru_styles_remove_preset_button_title(inputs)
	if (locale === "es") return es_styles_remove_preset_button_title(inputs)
	if (locale === "zh-CN") return zh_cn2_styles_remove_preset_button_title(inputs)
	if (locale === "ja") return ja_styles_remove_preset_button_title(inputs)
	if (locale === "hi") return hi_styles_remove_preset_button_title(inputs)
	if (locale === "pt-PT") return pt_pt2_styles_remove_preset_button_title(inputs)
	return en_styles_remove_preset_button_title(inputs)
});